export const getHydraAssignmentValue = (featureValue: string | number | boolean) => {
  const numValue = Number(featureValue);

  return isNaN(numValue) ? 0 : numValue;
};
